import styled from 'styled-components';

import { theme } from 'assets/styles/theme';
import ArrowBackSource from 'assets/svg/arrow-back.svg';
import { H6 } from 'components/typography/Headers';

const Button = styled.button`
  display: flex;
  flex-direction: row;
  align-items: center;
  align-self: flex-start;
  margin-bottom: 24px;
  padding: 0;
  border: none;
  background: none;
  cursor: pointer;
  color: ${theme.color.lightBlack};
`;

const ArrowBackIcon = styled.img`
  width: 18px;
  height: 17px;
  margin-right: 10px;
`;

const BackText = styled(H6)`
  font-weight: 700;
`;

interface Props {
  onClick: () => void;
  label: string;
}

export const PopupBackButton = ({ onClick, label }: Props) => {
  return (
    <Button data-testid={'back-button'} type={'button'} onClick={onClick}>
      <ArrowBackIcon src={ArrowBackSource} alt='' />
      <BackText>{label}</BackText>
    </Button>
  );
};
